exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-1b62d872]{position:fixed;top:7%;left:50%;transform:translateX(-50%);z-index:1060}ul li[data-v-1b62d872]{margin-bottom:7px}", ""]);

// exports
